import React, { useCallback, useEffect } from "react";
import { Route, Routes } from "react-router-dom";

import Home from "./pages/home";
import store from "../src/redux/store";
import ItemDetails from "./pages/item-details";
import LoginComp from "./pages/login";
import SignUp from "./pages/sign-up";

import { getCookies } from "./utils/cookies";
import {
  user_load_by_token_thunk,
  user_logout_thunk
} from "./redux/thunk/user_thunk";
import { useQuery } from "./hooks/urlSearchParams";
import ExploreMarketplace from "./pages/explore-marketplace";
import MainLayout from "./components/layout-component/main-layout";
import Profile from "./pages/profile";
import DaoPage from "./pages/dao";
import StakingPage from "./pages/staking";
import TokenSwapPage from "./pages/token-swap";
import TermsAndConditons from "./pages/terms-conditions";
import { BAFTokenBalanceApi } from "./api/methods-marketplace";
import { useDispatch, useSelector } from "react-redux";
import { setBalance } from "./redux/reducer/user_reducer";
import ForgotPassword from "./pages/forgot-password";
import ResetPassword from "./pages/reset-password";
import { useWallet } from "./context/WalletContext";

function App() {
  const query = useQuery();
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const { disconnectWallet } = useWallet();

  useEffect(() => {
    const token = query.get("token") || getCookies();
    if (token) {
      store.dispatch(user_load_by_token_thunk(token)); // user me
    } else {
      store.dispatch(user_logout_thunk(disconnectWallet));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [store]);

  // Memoized balance fetch function
  const fetchBalance = useCallback(async () => {
    if (!user?.data?.address || !user?.data?.is_custodial_wallet) {
      return;
    }

    try {
      const response = await BAFTokenBalanceApi();
      if (response?.data?.balance !== undefined) {
        const balance = response.data.balance;
        dispatch(setBalance(balance));
      }
    } catch (error) {
      console.error("❌ Failed to fetch balance:", error);
    }
  }, [user?.data?.address, user?.data?.is_custodial_wallet, dispatch]);

  // Balance fetch effect
  useEffect(() => {
    fetchBalance();
  }, [fetchBalance]);

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<LoginComp />} />
      <Route path="/sign-up" element={<SignUp />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/" element={<MainLayout />}>
        <Route path="marketplace" element={<ExploreMarketplace />} />
        <Route path="profile" element={<Profile />} />
        <Route path="dao" element={<DaoPage />} />
        <Route path="staking" element={<StakingPage />} />
        <Route path="token-swap" element={<TokenSwapPage />} />
        <Route path="item-details/:slug" element={<ItemDetails />} />
        <Route path="terms-and-conditions" element={<TermsAndConditons />} />
      </Route>
    </Routes>
  );
}

export default App;
